export const techStack = [
  {
    name: 'HTML5',
    link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg',
  },
  {
    name: 'CSS3',
    link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg',
  },
  {
    name: 'Bootstrap',
    link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg',
  },
  {
    name: 'TypeScript',
    link: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg',
  },
  {
    name: 'Javascript',
    link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg',
  },
  {
    name: 'React.js',
    link: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg',
  },
  {
    name: 'Redux',
    link: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg',
  },
  {
    name: 'Express.js',
    link: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg',
  },
  {
    name: 'Node.js',
    link: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg',
  },
  {
    name: 'Mongo DB',
    link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg',
  },
  {
    name: 'Gatsby.js',
    link: 'https://www.vectorlogo.zone/logos/gatsbyjs/gatsbyjs-icon.svg',
  },
  {
    name: 'Postman',
    link: 'https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg',
  },
  {
    name: 'Sass',
    link: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/sass/sass-original.svg',
  },
  {
    name: 'Tailwind CSS',
    link: 'https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg',
  },
  {
    name: 'Heroku',
    link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-plain.svg',
  },
  {
    name: 'Git',
    link: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg',
  },
  {
    name: 'Github',
    link: 'https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg',
  },
  {
    name: 'WordPress',
    link: 'https://upload.wikimedia.org/wikipedia/commons/0/09/Wordpress-Logo.svg',
  },
];

export const contactLinks = [
  {
    name: 'Facebook',
    url: 'https://upload.wikimedia.org/wikipedia/en/thumb/0/04/Facebook_f_logo_%282021%29.svg/256px-Facebook_f_logo_%282021%29.svg.png?20210818083032',
    link: 'https://www.facebook.com/imvshah105',
  },
  {
    name: 'Instagram',
    url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/256px-Instagram_icon.png',
    link: 'https://www.instagram.com/vish__105/',
  },
  {
    name: 'Github',
    url: 'https://www.seekpng.com/png/detail/101-1017465_github-github-icon-png-grey.png',
    link: 'https://github.com/vinayshah105',
  },
  {
    name: 'LinkedIn',
    url: 'https://cdn-icons-png.flaticon.com/256/174/174857.png',
    link: 'https://www.linkedin.com/in/vinay-shah007/',
  },
  {
    name: 'Twitter',
    url: 'https://cdn.cdnlogo.com/logos/t/96/twitter-icon.svg',
    link: 'https://twitter.com/vinay_shah007',
  },
];

export const data = {
  experience: [
    {
      companyName: 'Centurion Technology Solutions Inc',
      position: 'Full Stack Developer',
      des: 'Working with eCommerce platforms and create custom plugins for WordPress, OpenCart, Drupal, and Shopify. For Client-side Developed login screen, drag and drop and delete feature, image upload, content editor feature. Some plugins are User tracking, Book an Appointment, Chat support, Invoicing, etc. Registration form, display payment messages from Global Pay API and created an admin panel.',
      year: "Feb'21-Current",
      techSkills: [
        {
          techName: 'JavaScript',
        },
        {
          techName: 'REACT',
        },
        {
          techName: 'Node JS',
        },
        {
          techName: 'Express',
        },
        {
          techName: 'MongoDB',
        },
      ],
    },
  ],
  education: [
    {
      index: 1,
      name: 'TrainingHub.io',
      degree: 'Full Stack Web Development',
      year: "Feb'20 - Jun'20",
      des: '24-weeks full-stack web development training learning HTML, CSS, JavaScript, Tailwind, Bootstrap, SASS React Native, MongoDB, GitHub, Node.js, Express, WordPress etc.',
    },
    {
      index: 2,
      name: 'Fanshawe College - London',
      degree: 'Ontario College Diploma Program',
      year: "Jan'18 - Dec'19",
    },
    {
      index: 3,
      name: 'Gujarat Technological University',
      degree: 'Bachelor of Engineering',
      year: "Jun'13 - May'17",
    },
  ],
};
